<!--
 * @Description: 
 * @Date: 2022-04-20 17:25:59
-->
<template>
  <div class="relativeBox">
    <tag></tag>
    <component :is="editName"></component>
    <div v-if="businessDesc.isShow" @click="explainShow" class="explainBox">
      <span>业务说明</span>
      <img
        style="width: 20px;height: 20px;"
        src="//cdn.yxvzb.com/WEB/SaaS/images/mgmt/wenhao.png"
      />
    </div>
  </div>
</template>
<script>
import { mapState } from 'vuex';
import createExtend from '@/components/createExtend';
import BusinessDescription from './BusinessDescription';
import { bizDesc } from '@/api/ajax';

import tag from '@/components/Common/tag.vue';
import academyDetail from '@/page/academy/child/add-edit.vue';
import otcDetail from '@/page/otc/child/add-edit.vue';
import kshDetail from '@/page/ksh/child/add-edit.vue';
import hjhDetail from '@/page/hjh/child/add-edit.vue';
import surveyDetail from '@/page/survey/child/add-edit.vue';
import spreadDetail from '@/page/spread/child/add-edit.vue';
import yshSurveyDetail from '@/page/yshSurvey/child/add-edit.vue';
import caseDetail from '@/page/case/child/add-edit.vue';
import lvlHospitalDetail from '@/page/lvlHospital/child/add-edit.vue';
import baseHospitalDetail from '@/page/baseHospital/child/add-edit.vue';
import accessSuperDetail from '@/page/accessSuper/child/add-edit.vue';
import accessThirdDetail from '@/page/accessThird/child/add-edit.vue';
import accessSecondDetail from '@/page/accessSecond/child/add-edit.vue';
import accessBaseDetail from '@/page/accessBase/child/add-edit.vue';
import accessRetailDetail from '@/page/accessRetail/child/add-edit.vue';
import healthDetail from '@/page/health/child/add-edit.vue';
import digitalDetail from '@/page/digital/child/add-edit.vue';
import zsCaseDetail from '@/page/zsCase/child/add-edit.vue';
import protocolServiceDetail from '@/page/protocolService/child/add-edit.vue';
import editSceneDetail from '@/page/editScene/child/add-edit.vue';
import digitalQuestionnaireDetail from '@/page/digitalQuestionnaire/child/add-edit.vue';

// import { projectAllList } from '@/config/staticData';
// const obj = {};
// projectAllList.forEach(item => {
//   obj[`${item.filePath}Detail`] = () =>
//     import(`@/page/${item.filePath}/child/add-edit.vue`);
// });

export default {
  components: {
    academyDetail,
    otcDetail,
    kshDetail,
    hjhDetail,
    surveyDetail,
    spreadDetail,
    yshSurveyDetail,
    caseDetail,
    lvlHospitalDetail,
    baseHospitalDetail,
    accessSuperDetail,
    accessThirdDetail,
    accessSecondDetail,
    accessBaseDetail,
    accessRetailDetail,
    healthDetail,
    digitalDetail,
    zsCaseDetail,
    protocolServiceDetail,
    editSceneDetail,
    digitalQuestionnaireDetail,
    tag
  },
  data() {
    return {
      // componentsObj: obj,
      type: localStorage.projectType,
      componentName: '',
      businessDesc: {}
    };
  },
  computed: {
    ...mapState({
      editName: state => state.homeProject.editName,
      projectId: state => state.homeProject.id
    })
  },
  methods: {
    explainShow() {
      createExtend(BusinessDescription, {
        businessDesc: this.businessDesc.info
      });
    }
  },
  async created() {
    const { pdata } = await bizDesc({ projectId: this.projectId });
    this.businessDesc = pdata;
  }
};
</script>
<style lang="scss" scoped>
.relativeBox {
  position: relative;
  ::v-deep {
    .ruleForm {
      margin: 0;
      padding-top: 30px;
    }
  }
  .explainBox {
    display: flex;
    align-items: center;
    color: #606266;
    margin-bottom: 12px;
    cursor: pointer;
    margin: 0 12px 12px 0;
    position: absolute;
    right: 30px;
    top: 40px;
    span {
      margin-right: 5px;
    }
  }
}
</style>
